/* eslint-disable camelcase */
import { CompanyAttributes } from "interfaces/api/apiInterfaces";

/**
 * Compresses a company object by removing unused properties and filtering out empty arrays.
 * Maps specific properties to extract only their names.
 * Specifically
 * * Perks and Benefits should only have name value and perks.
 * * Each perk array should only be the names.
 * * Industries should only be the names.
 * * leadership_attributes should only be the names.
 *
 * @param company - The input object representing a company.
 * @returns A compressed version of the company object with removed properties, and filtered arrays.
 */
const compressedCompany = (company: Record<string, any>) => {
    const {
        id,
        legacy_id,
        logo,
        name,
        short_name,
        description,
        short_description,
        snapshot_photo,
        state,
        size,
        employee_range,
        industries,
        perks_and_benefits,
        leadership_attributes,
    } = company;

    const PerkBucket = {};

    // Remove all the unused stuff.
    Object.keys(perks_and_benefits)
        .filter(Boolean)
        .forEach((bucket) => {
            if (!perks_and_benefits[bucket].perks.length) return;
            PerkBucket[bucket] = {
                name: perks_and_benefits[bucket].name,
                value: perks_and_benefits[bucket].value,
                perks: perks_and_benefits[bucket].perks
                    .filter(Boolean)
                    .map((x: CompanyAttributes) => x.name)
            };
        });

    return {
        id,
        legacy_id,
        logo,
        name,
        short_name,
        description,
        short_description,
        snapshot_photo,
        state,
        size,
        employee_range,
        industries: industries
            .filter(Boolean)
            .map((x: CompanyAttributes) => x.name),
        perks_and_benefits: PerkBucket,
        leadership_attributes: leadership_attributes
            .filter(Boolean)
            .map((x: CompanyAttributes) => x.name),
    };
};

export {
    compressedCompany
};
